// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Js_array from "rescript/lib/es6/js_array.js";
import * as Caml_option from "rescript/lib/es6/caml_option.js";

function MakePair(C) {
  var state = {
    contents: C.defaultValue
  };
  var subscriptions = {
    contents: []
  };
  var addSubscription = function (f) {
    subscriptions.contents = Js_array.concat([f], subscriptions.contents);
    return function () {
      subscriptions.contents = Js_array.filter((function (sub) {
              return sub !== f;
            }), subscriptions.contents);
    };
  };
  var updateState = function (newStateOpt) {
    var newState = newStateOpt !== undefined ? Caml_option.valFromOption(newStateOpt) : C.defaultValue;
    state.contents = newState;
    Js_array.forEach((function (f) {
            f(newState);
          }), subscriptions.contents);
  };
  var Context$MakePair$Provider = function (props) {
    var value = props.value;
    React.useEffect((function () {
            updateState(value);
          }), [value]);
    return props.children;
  };
  var Provider = {
    make: Context$MakePair$Provider
  };
  var Context$MakePair$Consumer = function (props) {
    var match = React.useReducer((function (param, action) {
            return action._0;
          }), state.contents);
    var send = match[1];
    React.useEffect((function () {
            return addSubscription(function (newState) {
                        send({
                              TAG: "ChangeState",
                              _0: newState
                            });
                      });
          }), []);
    return props.children(match[0]);
  };
  var Consumer = {
    make: Context$MakePair$Consumer
  };
  return {
          state: state,
          subscriptions: subscriptions,
          addSubscription: addSubscription,
          updateState: updateState,
          Provider: Provider,
          Consumer: Consumer
        };
}

export {
  MakePair ,
}
/* react Not a pure module */
